import { RootState } from '../reducers'

export const themeSelector = (state: RootState) => state.theme
